import { createDraftSafeSelector } from '@reduxjs/toolkit';

const selectSelf = (state: RootState) => state.auctionsWatch;

const auctionsWatchSelector = createDraftSafeSelector(selectSelf, (state) => {
  if (state.pending?.auctionId) {
    return {
      ...state.auctions,
      [state.pending.auctionId]: state.pending.watch,
    };
  }

  return state.auctions;
});

const hasWatchedAuctionsSelector = createDraftSafeSelector(
  selectSelf,
  (state) => Object.keys(state.auctions).length > 0,
);

const pendingAuctionsSelector = createDraftSafeSelector(selectSelf, (state) => state.pending);

export const auctionsWatchSelectors = {
  auctionsWatchSelector,
  hasWatchedAuctionsSelector,
  pendingAuctionsSelector,
};
